import React from "react";
import { TabPanel } from "@ingka/tabs";
import CarouselItem from './CarouselItem';
import Carousel from "@ingka/carousel";

const TabPanelItem = (props) => {

    const displayPopupOnClick = (props) =>{
        console.log("clickImage in  TabPanelItem:::",props);
        props.onClick(props);
        // setModalIsOpen(true);
    }

    return (
        <>
            <TabPanel
                key={props.TabPanel.id}
                tabPanelId={props.TabPanel.tabPanelId}
            >
            <Carousel>
            {props.TabPanel.carousel.map((carouselItem,i)=>(
                <CarouselItem 
                    className={carouselItem.className}
                    key={i}
                    image={carouselItem.imagePath}
                    NameofDish = {carouselItem.NameofDish}
                    title = {carouselItem.title}
                    onClick = {()=>displayPopupOnClick(props)}
                />
            ))}
            </Carousel>
            </TabPanel>
        </>
    );
}

export default TabPanelItem;
